export const EMPTY_COFFRE_SEGMENT_FORM = {
  segment_name: "",
  segment_content: "",
  ordre_segment: 0,
  is_coffre_fort: true,
};

export const EMPTY_FILE_FORM = {
  nom_fichier: "",
  lien_fichier: "",
  detail_fichier: "",
};

export const COFFRE_QUILL_MODULES = {
  toolbar: [
    [{ header: "1" }, { header: "2" }, { font: [] }],
    [{ size: [] }],
    ["bold", "italic", "underline", "strike", "blockquote"],
    [{ color: [] }, { background: [] }],
    [{ script: "sub" }, { script: "super" }],
    [
      { list: "ordered" },
      { list: "bullet" },
      { indent: "-1" },
      { indent: "+1" },
    ],
    ["link", "image", "video"],
    ["clean"],
  ],
};

export const COFFRE_QUILL_FORMATS = [
  "header",
  "font",
  "size",
  "bold",
  "italic",
  "underline",
  "strike",
  "blockquote",
  "color",
  "background",
  "script",
  "list",
  "bullet",
  "indent",
  "link",
  "image",
  "video",
];

export function safeArray(value) {
  return Array.isArray(value) ? value : [];
}

export function toNumber(value, defaultValue = 0) {
  const number = Number(value);
  return Number.isFinite(number) ? number : defaultValue;
}

export function normalizeText(value = "") {
  return String(value)
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .trim();
}

export function stripHtml(value = "") {
  return String(value)
    .replace(/<[^>]*>/g, " ")
    .replace(/\s+/g, " ")
    .trim();
}

export function sortSegments(rows) {
  return safeArray(rows)
    .slice()
    .sort((a, b) => {
      const orderA = toNumber(a?.ordre_segment, 0);
      const orderB = toNumber(b?.ordre_segment, 0);

      if (orderA !== orderB) return orderA - orderB;

      return String(a?.segment_name || "").localeCompare(
        String(b?.segment_name || ""),
        "fr"
      );
    });
}

export function filterSegments(segments, search) {
  const query = normalizeText(search);

  if (!query) return sortSegments(segments);

  return sortSegments(segments).filter((segment) => {
    const files = safeArray(segment?.fichiers)
      .map(
        (file) =>
          `${file?.nom_fichier || ""} ${file?.detail_fichier || ""} ${
            file?.lien_fichier || ""
          }`
      )
      .join(" ");

    const searchable = normalizeText(
      `${segment?.segment_name || ""} ${stripHtml(
        segment?.segment_content || ""
      )} ${files}`
    );

    return searchable.includes(query);
  });
}

export function getNextSegmentOrder(segments) {
  return safeArray(segments).reduce((max, segment) => {
    return Math.max(max, toNumber(segment?.ordre_segment, 0));
  }, 0) + 1;
}

export function buildSegmentPayload(segment) {
  return {
    segment_name: String(segment?.segment_name || "").trim(),
    segment_content: String(segment?.segment_content || ""),
    ordre_segment: toNumber(segment?.ordre_segment, 0),
    is_coffre_fort: true,
  };
}

export function validateSegmentPayload(payload) {
  if (!payload.segment_name) return "Le nom du segment est requis.";

  if (!Number.isFinite(Number(payload.ordre_segment))) {
    return "L’ordre du segment doit être un nombre.";
  }

  return "";
}

export function buildFilePayload(fileForm, segmentId) {
  return {
    id: fileForm?.id || undefined,
    segment_id: segmentId,
    nom_fichier: String(fileForm?.nom_fichier || "").trim(),
    lien_fichier: String(fileForm?.lien_fichier || "").trim(),
    detail_fichier: String(fileForm?.detail_fichier || "").trim(),
  };
}

export function validateFilePayload(payload) {
  if (!payload.nom_fichier) return "Le nom du fichier est requis.";
  if (!payload.lien_fichier) return "Le lien du fichier est requis.";

  return "";
}

export function calculateCoffreStats(segments) {
  const rows = safeArray(segments);

  const filesCount = rows.reduce((total, segment) => {
    return total + safeArray(segment?.fichiers).length;
  }, 0);

  const withContent = rows.filter((segment) =>
    stripHtml(segment?.segment_content || "")
  ).length;

  const withoutFiles = rows.filter(
    (segment) => safeArray(segment?.fichiers).length === 0
  ).length;

  return {
    totalSegments: rows.length,
    filesCount,
    withContent,
    withoutFiles,
  };
}

export function extractCreatedSegmentId(response) {
  const data = response?.data ?? response;

  return (
    data?.id ||
    data?.insertId ||
    data?.segment?.id ||
    data?.data?.id ||
    data?.data?.insertId ||
    data?.payload?.id ||
    null
  );
}